<div class="card-container">
    <mat-card class="example-card">
        <mat-card-header>
            <mat-card-title>Gestor de departamentos</mat-card-title>
            <mat-card-subtitle></mat-card-subtitle>
        </mat-card-header>
        
        <mat-card-content>
            <div class="spinner" *ngIf="isLoading">
                <mat-spinner color="accent"></mat-spinner>
            </div>
            <div class="bt col-md-12 text-align-right">
                <button class="flat" color="primary" mat-flat-button [routerLink]="['/rrhh/gestor-de-puestos-de-trabajo/gestor-area-departamento/registrar']" >
                    Registrar nuevo departamento
                </button>
                &nbsp;
                <!--<button class="flat" color="primary" mat-flat-button>Comparativo</button>&nbsp;
                    <button class="flat" color="primary" mat-flat-button>Gráfica (Pizza)</button>-->
                </div>

                <!-- tabla -->
                <div class="row mt-5 mat-elevation-z8">
                    
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                        <caption><!--Parrilla--></caption>
                        <!-- contenido -->

                        <ng-container matColumnDef="id">
                            <th id="id" mat-header-cell *matHeaderCellDef> ID </th>
                            <td mat-cell *matCellDef="let element">&nbsp;{{element?.id_departamento_pk}}&nbsp;</td>
                        </ng-container>

                        <ng-container matColumnDef="area_o_departamento">
                            <th id="area_o_departamento" mat-header-cell *matHeaderCellDef> AREA O DEPARTAMENTO </th>
                            <td mat-cell *matCellDef="let element">&nbsp;{{element?.departamento}}&nbsp;</td>
                        </ng-container>

                        <ng-container matColumnDef="modificar">
                            <th id="modificar" mat-header-cell *matHeaderCellDef> MODIFICAR </th>
                            <td mat-cell *matCellDef="let element">&nbsp;
                                <button type="button" mat-mini-fab color="primary" >
                                    <mat-icon class="material-icons" [routerLink]="['/rrhh/gestor-de-puestos-de-trabajo/gestor-area-departamento/modificar']" [queryParams]="{id_depa:element.id_departamento_pk}">
                                        open_in_new
                                    </mat-icon>
                                </button>&nbsp;
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="eliminar">
                            <th id="eliminar" mat-header-cell *matHeaderCellDef> ELIMINAR </th>
                            <td mat-cell *matCellDef="let element">&nbsp;
                                <button type="button" mat-mini-fab color="warn" (click)="postEliminarDepartamento(element.id_departamento_pk)">
                                    <mat-icon class="material-icons">
                                        delete
                                    </mat-icon>
                                </button>&nbsp;
                            </td>
                        </ng-container>

                        <!-- fin contenido -->
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
                <!-- fin tabla -->

                <div class="mt-5 d-flex justify-content-center">
                    <button class="flat" color="primary" mat-flat-button [routerLink]="['/rrhh/gestor-de-puestos-de-trabajo']" >
                        Regresar
                    </button>
                </div>

                
            </mat-card-content>
        </mat-card>
    </div>
